<template>
  <div class="page page--bid-areas">
    <a
        v-for="item in list"
        :href="item.url"
        class="page-explorer__block"
        v-bind:key="item.name"
    >
      <div class="page-explorer-block__icon">
        <img :src="item.logo" :alt="item.name">
      </div>
      <div class="page-block__heading" style="color: black; text-shadow: none;">{{ item.name }} <span style="font-size: 1rem;">({{ item.websiteStatus }})</span></div>
    </a>
    <a href="" class="page-explorer__block">
      <div class="page-block__heading" style="color: black; text-shadow: none;">Get Your BID Seen Here</div>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: []
    }
  },
  mounted() {
    fetch('https://us-central1-chameleon-isb.cloudfunctions.net/api/bid-websites', {
      method: 'GET',
      headers: {
        'x-secret': 'chameleon-isb-mini-site'
      }
    }).then(res => res.json()).then(result => {
      this.list = result;
    }).catch(e => {
      console.log(e);
    });
  }
}
</script>
